import { sitesConstants as sts } from "../../../constants/sites";

const initialState = { loading: true, list: [], data: null, salles: [] };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case sts.GET_SITES:
      let array = [];
      payload.map((s) => {
        s.salles.map((sl) => {
          array.push(sl);
        });
      });
      return {
        ...state,
        loading: false,
        list: payload,
        salles: array,
      };
    case sts.GET_SITE:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case sts.SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
